import styled from 'styled-components';

const menuBtnSize = '50px';
const scrollDownPadding = '105px';
const menuBtnSizeReduced = '45px';
const scrollDownPaddingReduced = '85px';

export const SFCContainer = styled.div`
  background: transparent;
  display: ${(props) => (props.hideBottomButtons ? 'none' : 'block')};
  position: absolute;
  z-index: 3;
  align-items: center;
  bottom: ${(props) => props.alturaBtnSelectorFons + 'px'};
  right: 0;
  padding: 0 10px;
`;

export const SFCIconBtnWrapper = styled.div`
  display: flex;
  text-align: center;
  margin: auto;
  height: 60px;
  width: 100%;
`;

export const SFCIconBtn = styled.button`
  display: flex;
  border-radius: 50%;
  height: ${menuBtnSizeReduced};
  justify-content: center;
  align-items: center;
  border: 0;
  margin: auto;
  width: ${menuBtnSizeReduced};
  z-index: 3;
  background-color: ${({ selected }) => (selected ? '#febf00' : '#666666')};

  @media screen and (max-width: 768px) {
    height: ${menuBtnSize};
    width: ${menuBtnSize};
  }
`;

export const SFCIcon = styled.img`
  vertical-align: middle;
  text-align: center;
  margin: auto;
  display: flex;
  filter: ${({ selected }) => (selected ? 'none' : 'brightness(0) invert(1)')};
  opacity: 100%;
`;

export const SFCWrapper = styled.div``;

export const SFCMenuWrapper = styled.div`
  display: ${({ open }) => (open ? 'block' : 'none')};
  text-align: center;
  flex-direction: column;
  position: fixed;
  bottom: ${(props) => props.alturaBtnSelectorFonsAux};
  right: 9px;
  padding: 10px;
  padding-bottom: 45px;
  padding-right: 0;
  border-bottom-right-radius: 35px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 5px;
  background-color: rgba(51, 51, 51, 0.85);
  z-index: 2;
  width: 480px;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  align-items: center;
  color: #fff;
  max-height: ${({ alturaBtnSelectorFonsAux }) => `calc(100% - 110px - ${alturaBtnSelectorFonsAux})`};

  //mini-tablet || mobile rotated
  @media screen and (max-width: 768px) {
    max-height: ${({ alturaBtnSelectorFonsAux }) => `calc(100% - 80px - ${alturaBtnSelectorFonsAux})`};
    width: 95%;
    border-bottom-right-radius: 25px;
    right: 10px;

    ::-webkit-scrollbar-track {
      margin-bottom: ${scrollDownPaddingReduced};
    }
  }

  //mobile
  @media screen and (max-width: 464px) {
    /* height: 40vh; */
    max-height: ${({ alturaBtnSelectorFonsAux }) => `calc(100% - 80px - ${alturaBtnSelectorFonsAux})`};
    width: 95%;
  }
`;

export const FondosWrapper = styled.div`
  overflow-y: inherit;
  overflow-x: hidden;
  max-height: ${({ alturaBtnSelectorFonsAux }) => `calc(100vh - 160px - ${alturaBtnSelectorFonsAux})`};

  @media screen and (max-width: 768px) {
    max-height: ${({ alturaBtnSelectorFonsAux }) => `calc(100vh - 140px - ${alturaBtnSelectorFonsAux})`};
  }

  ::-webkit-scrollbar {
    background-color: transparent;
    opacity: ${({ hovering }) => (hovering ? '1' : '0')};
    display: block;
    width: 7px;
    height: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 1em;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 1em;
    margin-top: 5px;
    /* margin-bottom: ${scrollDownPadding}; */
    margin-right: ${menuBtnSize};
    margin-left: 5px;
  }

  ::-webkit-scrollbar-track-piece :end {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-track-piece :start {
    background-color: transparent;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const SFCContractedMenuBtnSvg = styled.div`
  display: flex;
  border: 1px solid white;
  padding: 5px;
  margin-top: auto;
  margin-bottom: auto;
  filter: brightness(0) invert(1);
`;

export const SFCContractedMenuIcon = styled.img`
  vertical-align: middle;
  text-align: center;
  margin: 0.2em;
  display: flex;
  filter: ${({ selected }) => (selected ? 'none' : 'brightness(0) invert(1)')};
  border: 1px solid #fff;
  border-radius: 5px;
  width: 5em;
  opacity: 100%;

  @media screen and (max-width: 1024px) {
    width: 5em;
  }
`;
